import React from 'react';
import { Grid, Typography, styled } from '@mui/material';
import Footer from '@shared/layout/Footer';

import Header from '@shared/layout/Header';
import { sxStyle } from './styles';

const BodyContainer = styled('div')(() => ({
  backgroundColor: '#F6F6F6',
}));

export default () => {
  return (
    <BodyContainer>
      <Grid container direction="column" sx={sxStyle.siteContainer}>
        <Grid container direction="column" sx={sxStyle.headerContainer}>
          <Header />
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid container direction="column">
            <Grid container direction="column" sx={sxStyle.containerCompany}>
              <Typography component="h4" sx={sxStyle.title}>
                ¿Quiénes somos?
              </Typography>
              <Typography component="h5" sx={sxStyle.subTitle}>
                GIT - Operador Mayorista
              </Typography>
              <Grid container direction="row" sx={sxStyle.allContainers}>
                <Grid container sx={sxStyle.container1}>
                  <Typography component="p" sx={sxStyle.p}>
                    Somos una empresa mayorista de turismo que abrió sus puertas
                    en el año 2002. Ofrecemos a nuestros clientes una variedad
                    de destinos como Argentina, Brasil, Perú, todo Caribe,
                    Estados Unidos. Nuestras oficinas están en la ciudad de
                    Córdoba, aunque nuestra área de influencia abarca toda la
                    provincia de Córdoba, Noroeste argentino, Santa Fe, Paraná y
                    La Pampa.
                  </Typography>
                </Grid>
                <Grid container direction="column" sx={sxStyle.container2}>
                  <Typography component="p" sx={sxStyle.p}>
                    Nuestro principal objetivo es brindar productos de calidad,
                    satisfaciendo a los clientes finales, los pasajeros, y dando
                    respuesta rápida y de excelencia a las agencias de viajes,
                    nuestros clientes directos.
                  </Typography>
                  <Typography component="p" sx={sxStyle.p}>
                    Contamos con recursos humanos en constante capacitación y
                    apasionados de esta actividad, que siempre buscan complacer
                    a los clientes, con la premisa de ir siempre por más.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container sx={sxStyle.containerFooter}>
          <Footer />
        </Grid>
      </Grid>
    </BodyContainer>
  );
};
